import { read } from "@/api/rest";

const projectTaskTarget = {
  index: async (params = {}) => await read('/project-task-target', {params}),
};

export default projectTaskTarget;